var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 45,
    viewBox: "0 0 63 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.475 22.5C26.5663 22.5 31.5 17.4656 31.5 11.25C31.5 5.03437 26.5663 0 20.475 0C14.3837 0 9.45 5.03437 9.45 11.25C9.45 17.4656 14.3837 22.5 20.475 22.5ZM55.125 16.875C55.125 21.7586 51.2485 25.7143 46.4625 25.7143C41.6765 25.7143 37.8 21.7586 37.8 16.875C37.8 11.9912 41.6765 8.03571 46.4625 8.03571C51.2485 8.03571 55.125 11.9912 55.125 16.875ZM20.475 25.7143C24.7804 25.7143 31.7882 27.0821 36.3842 29.8048C38.2615 31.7547 39.375 33.8808 39.375 36V45H0V36C0 29.16 13.6414 25.7143 20.475 25.7143ZM63 45H42.525V36C42.525 33.7238 41.7195 31.6287 40.4403 29.7588C42.8672 29.2058 45.2565 28.9286 47.081 28.9286C52.9532 28.9286 63 31.8001 63 37.4999V45Z",
    fill: "#FF5910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitors);
export default __webpack_public_path__ + "static/media/Visitors.b25895bc8261428a52838e415585ca38.svg";
export { ForwardRef as ReactComponent };